<template>
  <div
    v-if="amount > 0 || label"
    class="flex gap-4 items-center"
  >
    <span class="font-normal text-xs flex-1">{{ label }}</span>
    <span
      v-if="amount > 0"
      class="text-EXPONDO-green font-bold text-sm"
    >
      {{ $n(amount * -1, 'currency') }}
    </span>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'DiscountCardItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
});

</script>
